module.exports = __webpack_public_path__ + "img/welcome.8a87b0a5.png";